<div class="quantity">
	<span class="decrement" (click)="increment(-1)">-</span>
	<input [(ngModel)]="quantity" [disabled]="multiple > 1 ? true : null" (keyup)="setQuantity();">
	<span class="increment" (click)="increment(1)">+</span>
</div>